// Shared icon-button + tooltip pattern for Inbox (Rahim, 2026-08-29: "we
// will be using it through out the inbox... proper best calling practice").
// One component instead of every call site re-wrapping its own IconButton in
// <Tooltip title=... arrow componentsProps={...}> — same style everywhere
// (DARK_BUBBLE_TOOLTIP_SX), same sensible hover delay, one place to change
// either later. MUI's Tooltip is already the efficient primitive underneath
// (lazily mounts its popper only while shown, no re-render of surrounding
// icons while idle) — this just removes the boilerplate around it, not a
// reimplementation.
import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { DARK_BUBBLE_TOOLTIP_SX } from "../../../utils/tooltipStyles";

// 400ms — long enough that sweeping the cursor across a dense icon row
// (composer, ChatboxNavbar, etc.) doesn't flash a tooltip per icon passed
// over, short enough to still feel responsive on a deliberate hover.
const DEFAULT_ENTER_DELAY = 400;

const IconButtonWithTooltip = React.forwardRef(function IconButtonWithTooltip(
  { label, placement = "top", children, disabled, sx, ...iconButtonProps },
  ref
) {
  // A disabled MUI IconButton doesn't fire pointer events, so a Tooltip
  // wrapping one directly never opens — span wrapper is MUI's own documented
  // fix (same pattern their docs use for "tooltip on disabled button").
  return (
    <Tooltip
      title={label}
      arrow
      placement={placement}
      enterDelay={DEFAULT_ENTER_DELAY}
      componentsProps={DARK_BUBBLE_TOOLTIP_SX}
    >
      <span>
        <IconButton ref={ref} disabled={disabled} sx={sx} {...iconButtonProps}>
          {children}
        </IconButton>
      </span>
    </Tooltip>
  );
});

export default IconButtonWithTooltip;
